"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subdomainsDisableOptionsDict = exports.defaultShareOptions = void 0;
const constants_1 = require("../../../../../constants");
exports.defaultShareOptions = {
    x: true,
    facebook: true,
    xing: true,
    yammer: true,
    whatsapp: true,
    embedCertificate: true,
    embedBadge: true,
};
// custom subdomains dict has specific DisableOptions
exports.subdomainsDisableOptionsDict = {
    [constants_1.Subdomains.foundationForHealthyStPetesburg]: {
        whatsapp: false,
        yammer: false,
        xing: false,
    },
    [constants_1.Subdomains.onvuLearning]: {
        // Only allow sharing to Facebook
        x: false,
        xing: false,
        yammer: false,
        whatsapp: false,
        embedCertificate: false,
        embedBadge: false,
    },
};
